import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, makeStyles } from '@material-ui/core';
import ScaleTile from '../../Scale/ScaleTile';
import RecycleScaleTile from '../../Scale/RecycleScaleTile';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';

export const ScaleOverviewPage = (props) => {
    const { t } = useTranslation();
    const classes = useStyles();

    function ClickTile(scale) {
        dataService.restartScale(scale).then(() => {
            toast.success(t('Weegschaal wordt herstart'), { position: "top-center" })
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }

    function ClickRecycleTile(scale) {
        dataService.restartRecycleScale(scale).then(() => {
            toast.success(t('Weegschaal wordt herstart'), { position: "top-center" })
        }).catch((error) => { toast.error(error, { position: "top-center" }) });
    }

    return (
        <div className={classes.background}>
            <div className={classes.spacer80}>
                {t("Scales")}
            </div>
            <Grid container spacing={2} className={classes.gridContainer}>
                <Grid className={classes.gridmargin} key={1} item>
                    <ScaleTile {...props} ClickTile={ClickTile} scale={1}></ScaleTile>
                </Grid>
                <Grid className={classes.gridmargin} key={2} item>
                    <ScaleTile {...props} ClickTile={ClickTile} scale={2}></ScaleTile>
                </Grid>
                <Grid className={classes.gridmargn} key={3} item>
                    <ScaleTile {...props} ClickTile={ClickTile} scale={3}></ScaleTile>
                </Grid>
                <Grid className={classes.gridmargin} key={4} item>
                    <ScaleTile {...props} ClickTile={ClickTile} scale={4}></ScaleTile>
                </Grid>
                <Grid className={classes.gridmargin} key={5} item>
                    <ScaleTile {...props} ClickTile={ClickTile} scale={5}></ScaleTile>
                </Grid>
                <Grid className={classes.gridmargin} key={6} item>
                    <RecycleScaleTile {...props} ClickTile={ClickRecycleTile} scale={5}></RecycleScaleTile>
                </Grid>
            </Grid>
        </div>
    )
}

const useStyles = makeStyles({
    background: {
        width: '100%',
        position: "relative",
        top: "60px",

    },
    spacer80: {
        height: '80px',
        color: "#000000",
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        paddingLeft: "20px"
    },
    gridContainer: {
        display: 'flex',
        justifyContent: 'center',
        maxWidth: "100%",
        marginRight: "auto",
        marginLeft: "auto"
    },
});